import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Modal, Alert, Button } from 'react-bootstrap'
import { createImpersonations } from '../action/userActions'

import loading from '../../assets/loading.svg'

class CreateImpersonations extends Component {
    constructor(props) {
        super(props)
        this.state = { show: false }
    }

    render() {
        const Result = (() => {

            return <table hidden={this.props.loading}>
                <thead>
                    <tr>
                        <th>
                            <h4>
                                Created Impersonation
                                </h4>
                        </th>
                    </tr>
                </thead>
                {this.props.createdImpersonations.map(user => {
                    return <tr>
                        <td>
                            {user.login}
                        </td>
                    </tr>
                })}
                <tr hidden={this.props.createdImpersonations.length > 0}>
                    <td>
                        None Created...
                    </td>
                </tr>







            </table>






        })

        return <div>
            <Button onClick={
                () => {
                    this.setState({ show: true })

                    console.log('already running', this.props.alreadyRunning)

                    if (!this.props.alreadyRunning)
                        this.props.dispatch(createImpersonations())
                }
            }>
                Create Impersonations
            </Button>

            <Modal show={this.state.show}>
                <Modal.Body>

                    <img hidden={!this.props.loading} style={{ width: '100%' }} src={loading} />

                    <Result />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => {
                        this.setState({ show: false })
                    }}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>


        </div>
    }



}

const mapStateToProps = state => (
    {
        loading: state.acct.user.loading,
        createdImpersonations: state.acct.user.createdImpersonations,
        alreadyRunning: state.acct.user.impersonationAlreadyRunning,
        error: state.acct.user.error
    });

export default connect(mapStateToProps)(CreateImpersonations)
